import React from 'react';
import { Field } from 'formik';
import { CustomSelectComponent } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { RouteTypes } from 'shared-pages/shared/constants';

/* ----------- Select Month ------------------ */
export const SelectRoute = ({
  required = false,
  name = 'routeTypeId',
  title = 'Τύπος Δρομολογίου',
  ...rest
}) => {
  const { t } = useTranslation();
  const monthOptions = [
    {
      value: RouteTypes.PrimaryToSecondaryStorage,
      label: t('Σημείο Πρωτογενούς Παραγωγής -> Δευτερογενής Αποθήκευση'),
    },
    {
      value: RouteTypes.PrimaryToRecyclingFacility,
      label: t('Σημείο Πρωτογενούς Παραγωγής -> Εγκατάσταση Ανακύκλωσης'),
    },
    {
      value: RouteTypes.SecondaryStorageToRecycling,
      label: t('Σημείο Δευτερογενούς Αποθήκευσης -> Εγκατάσταση Ανακύκλωσης'),
    },
    {
      value: RouteTypes.SecondaryToSecondaryStorage,
      label: t('Σημείο Δευτερογενούς Αποθήκευσης -> Άλλο Σημείο Δευτερογενούς Αποθήκευσης'),
    },
  ];

  return (
    <Field
      {...rest}
      required={required}
      name={name}
      title={t(title)}
      component={CustomSelectComponent}
      options={monthOptions}
    />
  );
};
